import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../../../../dishFullInfoState/dishFullInfoContext';
import style from './IsDisabledField.module.scss';

const IsDisabledField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	const isDisabledInRestaurants = dishForFullInfo?.restaurantsDishes.filter((el) => el.isDisabled);

	return (
		<div className={style.container}>
			<Text translationNameSpace="form" translationKey="dishInStopLabel" theme="neutralLight" size="xs" />
			<div className={style.restaurantsList}>
				{isDisabledInRestaurants?.length
					? isDisabledInRestaurants.map((el) => {
							return (
								<div key={el.restaurantId} className={style.item}>
									<div className={style.dot} />
									<Text translationKey={el.restaurantName} size="s" withTooltip={true} />
								</div>
							);
					  })
					: '-'}
			</div>
		</div>
	);
};

export default IsDisabledField;
